import { DEVICE, TYPOGRAPHY } from '@net0-calc/common/assets/styles';
import { FC } from 'react';
import { FieldInputProps } from 'react-final-form';
import styled from 'styled-components';

interface DropdownOption {
  title: string;
  value: string;
}

interface DropdownInterface extends FieldInputProps<string> {
  className?: string;
  label: string;
  options: DropdownOption[];
}

export const Dropdown: FC<DropdownInterface> = ({ label, className, options, inputRef, ...rest }) => {
  return (
    <Root className={className}>
      <StyledLabel>{label}</StyledLabel>
      <InputWrap>
        <StyledSelect ref={inputRef} {...rest}>
          {options.map(({ title, value }) => (
            <option key={value} value={value}>
              {title}
            </option>
          ))}
        </StyledSelect>
      </InputWrap>
    </Root>
  );
};

const Root = styled.div`
  width: 100%;
  margin-top: 16px;

  @media ${DEVICE.laptop} {
    margin-top: 8px;
  }
`;

const StyledLabel = styled.label`
  ${TYPOGRAPHY.captionRegular14};
  display: block;
  margin-bottom: 8px;
  color: var(--color9);
`;

const StyledSelect = styled.select`
  ${TYPOGRAPHY.bodyRegular16}
  color: var(--color6);
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;

  position: relative;
  width: 100%;
  height: 64px;
  padding: 0 44px 0 16px;

  border-radius: 12px;
  border: 1px solid var(--color10);
  background-color: var(--color5);
  background-image: url("data:image/svg+xml,%3Csvg width='12' height='8' viewBox='0 0 12 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L6 6.5L11 1.5' stroke='%236B6B6B' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  margin-bottom: 16px;

  @media ${DEVICE.laptop} {
    margin-bottom: 0;
  }

  &:hover {
    border-color: var(--color9);
  }

  &:focus {
    border-color: var(--color2);
    box-shadow: 0 0 0 3px rgba(206, 17, 38, 0.08);
  }

  & option {
    ${TYPOGRAPHY.bodyRegular16}
    padding: 8px;
  }
`;

const InputWrap = styled.div``;
